import { ExpandedQuote, PortfolioType } from '..';

export interface IWatchListQuotePortfolio {
  id: number;
  name: string;
  symbol: string;
  portfolioType: PortfolioType;
  isGlobal: boolean;
}

export interface IWatchListQuoteTradeIdea {
  isTradeIdea: boolean;
  sentiment: string | null;
  ruleMatch: string[];
}

export class Quote {
  position = -1;
  symbol = '';
  technicalRank = -1;
  price = -1;
  expandedQuote: ExpandedQuote | undefined;
  sentiment = '';
  portfolios: IWatchListQuotePortfolio[] = [];
  tradeIdeaInfo: IWatchListQuoteTradeIdea;
  isPinned = false;
  portfolioPositionsCount = 0;
  company = '';

  static fromData = (data: any) => {
    const quote = new Quote();
    quote.position = data.position;
    quote.symbol = data.symbol;
    quote.technicalRank = data.technicalRank;
    quote.price = data.price;
    quote.expandedQuote = data.expandedQuote;
    quote.sentiment = data.sentiment;
    quote.portfolios = data.portfolios;
    quote.tradeIdeaInfo = data.tradeIdeaInfo;
    quote.isPinned = data.isPinned;
    quote.portfolioPositionsCount = data.portfolioPositionsCount;
    quote.company = data.company;
    return quote;
  };

  static fromSelf = (self: Quote) => {
    if (!self) {
      throw new Error('Self is undefined');
    }
    const clone = new Quote();
    clone.position = self.position;
    clone.symbol = self.symbol;
    clone.technicalRank = self.technicalRank;
    clone.price = self.price;
    clone.expandedQuote = self.expandedQuote;
    clone.sentiment = self.sentiment;
    clone.portfolios = self.portfolios;
    clone.tradeIdeaInfo = self.tradeIdeaInfo;
    clone.isPinned = self.isPinned;
    clone.portfolioPositionsCount = self.portfolioPositionsCount;
    clone.company = self.company;
    return clone;
  };

  static sortvalue = '';
}
